export default "__VITE_ASSET__C$2TSQHf__"